import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from '../../Button/Button';

export interface IUploadButtonProps {
  readonly text: string;
}

export const UploadButton: React.FC<IUploadButtonProps> = ({ text }) => <Button icon={<PlusOutlined />}>{text}</Button>;
